import type { IChatListObject } from "./chat";

// NOTE: NSAI-4559 — the sidebar used to offer only Today / Last 30 days /
// Older, so every chat between yesterday and a month ago collapsed into one
// bucket. These are the ChatGPT-style buckets, shared by web and mobile so the
// two lists can never drift apart again.
export enum EChatDateGroupKind {
  TODAY = "today",
  YESTERDAY = "yesterday",
  PREVIOUS_7_DAYS = "previous7Days",
  PREVIOUS_30_DAYS = "previous30Days",
  MONTH = "month",
  YEAR = "year",
}

export interface IChatDateGroup {
  // NOTE: Stable, translation-independent identity — accordion open/closed
  // state keys off this. Month and year buckets carry their period in the key
  // ("month-2026-05", "year-2025") so several of them can coexist.
  key: string;
  kind: EChatDateGroupKind;
  // NOTE: The bucket's own timestamp. MONTH and YEAR labels are formatted from
  // it; the fixed buckets ignore it.
  referenceDate: Date;
  chats: IChatListObject[];
}

export interface IChatDateGroupIdentity {
  key: string;
  kind: EChatDateGroupKind;
}

export interface IResolveChatDateGroupProps {
  date: Date;
  now: Date;
}

export interface IAddDaysProps {
  date: Date;
  days: number;
}

export interface IGroupChatsByDateProps {
  chats: IChatListObject[];
  // NOTE: Injectable clock — keeps the function pure and unit-testable.
  now?: Date;
}

export interface IFormatChatDateGroupLabelProps {
  group: IChatDateGroup;
  locale: string;
  // NOTE: The consumer's i18n `t`, already bound to the sidebar namespace.
  translate: (key: string) => string;
}
